import { render, staticRenderFns } from "./VaagaiMalar2026.vue?vue&type=template&id=48b2d88a&scoped=true"
import script from "./VaagaiMalar2026.vue?vue&type=script&lang=js"
export * from "./VaagaiMalar2026.vue?vue&type=script&lang=js"
import style0 from "./VaagaiMalar2026.vue?vue&type=style&index=0&id=48b2d88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b2d88a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
